import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentResourceOperation, IntentResourceOperationState } from "types/generated";
import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

const IntentProjectOperationsTableStateReasonCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<IntentResourceOperation>) => {
  const hasFailedReason = item.state === IntentResourceOperationState.Failed && !!item.failed;

  return (
    <TableSimpleCell {...cellProps}>
      {!hasFailedReason && <TableCellEmpty />}
      {hasFailedReason && (
        <TableCellDescription
          description={item.failed}
          actionText="Show full text"
          drawerTitle="Failure reason"
        />
      )}
    </TableSimpleCell>
  );
};

export default IntentProjectOperationsTableStateReasonCell;
